<button [type]="type" class="button">
	<ng-content></ng-content>
</button>

<div class="spinner-wrapper" *ngIf="loading">
	<hum-spinner class="spinner"></hum-spinner>
</div>
